import React from 'react';
import { fade, makeStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Typography, Button, Menu, MenuItem, InputBase, IconButton, Theme } from '@material-ui/core';
import {
  More as MoreIcon,
  AccountCircle as AccountCircleIcon,
  Search as SearchIcon,
  Clear as ResetIcon,
} from '@material-ui/icons';
import { useSelector, useDispatch } from 'react-redux';
import { updateSearchKeyword, updateSearchStatus, setLogin } from '../../actions';
import { RootState } from '../../reducers';
import { TorrentStatus } from '../../types';
import { thunkFetchTorrents } from '../../thunks';
import Add from './Add';
import Delete from './Delete';
import Setting from './Setting';
import Archive from './Archive';
import Speed from '../Shared/Speed';


const useStyles = makeStyles((theme: Theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  logo: {
    width: '48px',
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  statuses: {
    marginLeft: theme.spacing(2),
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 1),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },

}));

export default function Header() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const { uploadSpeed, downloadSpeed } = useSelector((state: RootState) => state.stat);

  const dispatch = useDispatch();
  const search = useSelector((state: RootState) => state.search);

  const pickStatus = (status?: TorrentStatus) => {
    dispatch(updateSearchStatus(status));
    setAnchorEl(null);
  }

  const handleSearch = () => dispatch(thunkFetchTorrents());
  const handleReset = () => {
    dispatch(updateSearchKeyword(''));
    handleSearch();
  }

  const handleLogout = () => {
    dispatch(setLogin(true));
  }

  return (
    <AppBar position="static">
      <Toolbar>
        <img src="logo192.png" alt="logo" className={classes.logo} />
        <Typography className={classes.title} variant="h6" noWrap>
          ptrelay
        </Typography>
        <div className={classes.statuses}>
          <Button color="inherit" onClick={e => setAnchorEl(e.currentTarget)}>Status: {search.status || 'All'}</Button>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={open}
            onClose={() => setAnchorEl(null)}
          >
              <MenuItem onClick={() => pickStatus()}>ALL</MenuItem>
            {Object.values(TorrentStatus).map((status) =>
              <MenuItem key={status} onClick={() => pickStatus(status)}>{status}</MenuItem>
            )}
          </Menu>
        </div>
        <div className={classes.search}>
          <InputBase
            placeholder="keyword"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ 'aria-label': 'search' }}
            value={search.keyword}
            onKeyDown={e => {
              if (e.keyCode === 13) {
                handleSearch();
              }
            }}
            onChange={e => dispatch(updateSearchKeyword(e.target.value))}
          />
        </div>
        <IconButton color="inherit" onClick={handleSearch}>
          <SearchIcon></SearchIcon>
        </IconButton>
        <IconButton color="inherit" onClick={handleReset}>
          <ResetIcon></ResetIcon>
        </IconButton>
        <div className={classes.grow} />
        <div className={classes.sectionDesktop}>
          <Speed uploadSpeed={uploadSpeed} downloadSpeed={downloadSpeed} />
          <Add />
          <Delete />
          <Setting />
          <Archive />
          <IconButton edge="end" color="inherit" onClick={handleLogout}>
            <AccountCircleIcon />
          </IconButton>
        </div>
        <div className={classes.sectionMobile}>
          <IconButton color="inherit">
            <MoreIcon />
          </IconButton>
        </div>
      </Toolbar>
    </AppBar >
  )
}